// src/components/TemplateForm.js
import React, { useState, useEffect } from 'react';
import { TextField, Button, Grid } from '@mui/material';
import { collection, addDoc, updateDoc, doc } from 'firebase/firestore';
import { auth, db } from '../firebase';

const TemplateForm = ({ template, onSave }) => {
  const [templateName, setTemplateName] = useState('');
  const [campaignId, setCampaignId] = useState('');
  const [campaignSource, setCampaignSource] = useState('');
  const [campaignMedium, setCampaignMedium] = useState('');
  const [campaignName, setCampaignName] = useState('');
  const [campaignTerm, setCampaignTerm] = useState('');
  const [campaignContent, setCampaignContent] = useState('');
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (template) {
      setTemplateName(template.templateName);
      setCampaignId(template.campaignId);
      setCampaignSource(template.campaignSource);
      setCampaignMedium(template.campaignMedium);
      setCampaignName(template.campaignName);
      setCampaignTerm(template.campaignTerm);
      setCampaignContent(template.campaignContent);
    }
  }, [template]);

  const validate = () => {
    let tempErrors = {};
    tempErrors.campaignSource = campaignSource ? "" : "This field is required.";
    tempErrors.campaignMedium = campaignMedium ? "" : "This field is required.";
    tempErrors.campaignName = campaignName ? "" : "This field is required.";
    setErrors(tempErrors);
    return Object.values(tempErrors).every(x => x === "");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      const user = auth.currentUser;

      if (user) {
        try {
          if (template) {
            await updateDoc(doc(db, 'templates', template.id), {
              templateName,
              campaignId,
              campaignSource,
              campaignMedium,
              campaignName,
              campaignTerm,
              campaignContent,
            });
          } else {
            await addDoc(collection(db, 'templates'), {
              userId: user.uid,
              templateName,
              campaignId,
              campaignSource,
              campaignMedium,
              campaignName,
              campaignTerm,
              campaignContent,
              createdAt: new Date(),
            });
          }
          // Clear form fields
          setTemplateName('');
          setCampaignId('');
          setCampaignSource('');
          setCampaignMedium('');
          setCampaignName('');
          setCampaignTerm('');
          setCampaignContent('');
          onSave();
        } catch (error) {
          console.error('Error adding document: ', error);
        }
      }
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            label="Template Name (例: Summer Campaign)"
            variant="outlined"
            fullWidth
            value={templateName}
            onChange={(e) => setTemplateName(e.target.value)}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Campaign ID (例: summer2024)"
            variant="outlined"
            fullWidth
            value={campaignId}
            onChange={(e) => setCampaignId(e.target.value)}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Campaign Source (例: newsletter) *必須"
            variant="outlined"
            fullWidth
            value={campaignSource}
            onChange={(e) => setCampaignSource(e.target.value)}
            error={!!errors.campaignSource}
            helperText={errors.campaignSource}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Campaign Medium (例: email) *必須"
            variant="outlined"
            fullWidth
            value={campaignMedium}
            onChange={(e) => setCampaignMedium(e.target.value)}
            error={!!errors.campaignMedium}
            helperText={errors.campaignMedium}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Campaign Name (例: Summer Sale) *必須"
            variant="outlined"
            fullWidth
            value={campaignName}
            onChange={(e) => setCampaignName(e.target.value)}
            error={!!errors.campaignName}
            helperText={errors.campaignName}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Campaign Term (例: summer)"
            variant="outlined"
            fullWidth
            value={campaignTerm}
            onChange={(e) => setCampaignTerm(e.target.value)}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Campaign Content (例: special offer)"
            variant="outlined"
            fullWidth
            value={campaignContent}
            onChange={(e) => setCampaignContent(e.target.value)}
          />
        </Grid>
        <Grid item xs={12}>
          <Button variant="contained" color="primary" type="submit" fullWidth>
            {template ? 'Update Template' : 'Save Template'}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default TemplateForm;
